import React, { Component } from 'react';
import { ODataTable, FilterTypes, QueryOptions } from 'framework-ui-components';
import { StatiRicerca } from 'enums';

import RigaDichiarazione from './RigaDichiarazione';

class ElencoDichiarazioni extends Component {
  filtriStati = () => {
    const { stato } = this.props;

    let filters = [];

    if (stato == StatiRicerca.TUTTE || stato == 20) {
      filters = filters.concat([
        { description: 'In Lavorazione / Errate', value: 20 },
      ]);
    }
    if (stato == StatiRicerca.TUTTE || stato == 30) {
      filters = filters.concat([
        { description: 'Completa', value: 30 },
        { description: 'Stampata', value: 115 },
      ]);
    }
    if (stato == StatiRicerca.TUTTE || stato == StatiRicerca.TRASMESSE_EPASA) {
      filters = filters.concat([
        { description: 'In lavorazione EPASA', value: 120 },
        { description: 'Inviata INPS', value: 145 },
        { description: 'Accolta INPS', value: 135 },
      ]);
    }
    if (stato == StatiRicerca.TUTTE || stato == StatiRicerca.SCARTATA_EPASA) {
      filters = filters.concat([
        { description: 'Scartata EPASA', value: 130 },
        { description: 'Rifiutata INPS', value: 140 },
        { description: 'Reiezione INPS', value: 150 },
      ]);
    }
    return filters;
  };

  render() {
    const {
      urlRicerca, aggiornaDichiarazioniSelezionate, annoCampagna, ...rowProps
    } = this.props;

    const listastati = this.filtriStati();

    // anni filtro: dalla data inizio ad oggi
    const anni = [];
    for (let i = annoCampagna; i >= 2015; i--) {
      anni.push({ description: `${i}`, value: `${i}` });
    }

    const filtri = [
      {
        propertyName: 'Stato', descriptions: 'Stato', component: FilterTypes.SELECT, query: QueryOptions.EQUAL, options: listastati,
      },
      {
        propertyName: 'Tipo', descriptions: 'Tipo', component: FilterTypes.SELECT, query: QueryOptions.EQUAL, options: [{ description: 'Ordinario', value: '0' }, { description: 'Variazione', value: '19' }],
      },
      {
        propertyName: 'Anno', descriptions: 'Anno', component: FilterTypes.SELECT, query: QueryOptions.EQUAL, options: anni,
      },
    ];

    return (
      <ODataTable
        hover
        clickable
        selectable
        url={urlRicerca}
        row={RigaDichiarazione}
        pageSize={10}
        onSelezionati={aggiornaDichiarazioniSelezionate}
        additionalFilters={filtri}
        availablePageSizes={[10, 20, 50]}
        additionalRowData={rowProps}
      >
        <ODataTable.Column>Richiedente</ODataTable.Column>
        <ODataTable.Column className="w-180">CF richiedente</ODataTable.Column>
        <ODataTable.Column>Azienda</ODataTable.Column>
        <ODataTable.Column className="w-140">Stato</ODataTable.Column>
        <ODataTable.Column>Tipo</ODataTable.Column>
        <ODataTable.Column title="Il richiedente è un lavoratore dipendente del settore agricolo">D.Agr.</ODataTable.Column>
        <ODataTable.Column title="Annualità campagna ANF">Anno</ODataTable.Column>
        <ODataTable.Column>Periodo Dal</ODataTable.Column>
        <ODataTable.Column>Periodo Al</ODataTable.Column>
        <ODataTable.Column className="text--center">Stampato</ODataTable.Column>
        <ODataTable.Column className="w-140">Ultima modifica</ODataTable.Column>
        <ODataTable.Column />
        <ODataTable.Column className="w-40" />
      </ODataTable>
    );
  }
}

export default ElencoDichiarazioni;
